<template>
  <div>
    <div class="qrWrap">
      <p class="title">欢迎来到{{ APP_WINNY_NAME }}</p>
      <vue-qr class="qrStyle" :text="url" style="display: block" />
      <div class="bottomContent">
        <p class="text1">请使用手机扫码去解约</p>
        <p class="tip">
          解约时间<span v-html="tip"></span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
/*global http protocol */
import { mapGetters } from 'vuex'
import VueQr from 'vue-qr'
export default {
  name: 'UnSign',
  components: {
    VueQr
  },
  data() {
    return {
      tel: localStorage.getItem('myPhone'),
      baseUrl: window.g.APP_PATH_mobile,
      fundUrl: localStorage.getItem('qrContent'),
      url: '',
      APP_WINNY_NAME: window.g.APP_WINNY_NAME,
      tip: ''
    }
  },
  computed: {
    ...mapGetters(['isSignGetter'])
  },
  watch: {
    isSignGetter(val) {
      if (!val) {
        this.$router.push('/noSign')
      }
    }
  },
  mounted() {
    this.getTip()
    this.findUserStatusProcess()
  },
  methods: {
    // 查询解约时间提示信息
    getTip() {
      protocol.param_getContentDetails.param.id = 660
      http.getRes(protocol.param_getContentDetails).then((response) => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          this.tip = value.content
        } else {
          this.$toast(message)
        }
      })
    },
    // 查询用户状态 isAudit  pOro
    findUserStatusProcess() {
      http.postFront(protocol.param_findUserStatusProcess).then((response) => {
        const { code, message, value } = response.data
        this.isResponse = true
        if (code === 0 || code === '0') {
          if (value && value.audit) {
            // 代表已开户 true   false代表未开户
            // 个人还是企业
            if (value.poro === 'P') {
              this.getSessionKey()
            } else if (value.poro === 'O') {
              this.getSessionKey1()
            }
          }
        } else {
          this.$message(message)
        }
      })
    },
    // 得到秘钥 --- 个人签约
    getSessionKey() {
      http
        .getRes(protocol.param_getSessionKey4)
        .then((response) => {
          var { code, message, value } = response.data
          if (Number(code) === 0) {
            this.url = `${this.baseUrl}key=${value}&tel=${this.tel}`
          } else {
            this.$message(message)
          }
        })
        .catch(() => {
          // setTimeout(() => {
          //   this.queryQuantity()
          // }, 1000)
        })
    },
    // 得到秘钥 --- 企业签约
    getSessionKey1() {
      http
        .getRes(protocol.param_getSessionKey5)
        .then((response) => {
          var { code, message, value } = response.data
          if (Number(code) === 0) {
            this.url = `${this.baseUrl}key=${value}&tel=${this.tel}`
          } else {
            this.$message(message)
          }
        })
        .catch(() => {
          // setTimeout(() => {
          //   this.queryQuantity()
          // }, 1000)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.qrWrap {
  width: 730px;
  background-color: #fff;
  border-radius: 12px;
  margin: 0 auto;
  margin-top: 80px;
  .title {
    font-size: 30px;
    font-weight: 600;
    color: #171c23;
    padding: 30px 40px;
    padding-bottom: 0;
    text-align: center;
  }
  .qrStyle {
    width: 400px;
    height: 400px;
    margin: 0 auto;
  }
  .text1 {
    font-weight: 600;
    color: #171c23;
    text-align: center;
    font-size: 30px;
  }
  .tip {
    padding: 14px 0 60px 0;
    font-weight: 500;
    color: #000000;
    text-align: center;
    font-size: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      padding-left: 10px;
      font-weight: 600;
      color: #D94066;
      font-size: 16px;
    }
    P {
      display: inline;
    }
  }
}
</style>
